import ImgFlag from '../../assets/flag.svg'
import ImgDots from '../../assets/icon-dots.svg'
import ImgMarker from '../../assets/marker.svg'
import ImgTruckMarker from '../../assets/truck-marker.svg'

export const defaultMapContainerStyle = {
  width: '400px',
  height: '400px',
}

export const DEFAULT_PRIMARY_ROUTE_COLOR = '#005454'
export const DEFAULT_PRIMARY_ROUTE_WEIGHT = 3

export const DEFAULT_ALTERNATIVE_ROUTE_COLOR = '#003333'
export const DEFAULT_ALTERNATIVE_ROUTE_WEIGHT = 2

export const DEFAULT_MARKER_ICON = ImgMarker
export const DELIVERY_MARKER_ICON = ImgFlag
export const TRUCK_MARKER_ICON = ImgTruckMarker
export const IN_TRANSIT_CHECK_ICON = ImgDots

export const defaultMapStyles = [
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text',
    stylers: [{ weight: '1.00' }, { lightness: '10' }],
  },
  {
    featureType: 'administrative.locality',
    elementType: 'labels.text.fill',
    stylers: [{ lightness: '10' }],
  },
  {
    featureType: 'administrative.neighborhood',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'landscape.man_made',
    elementType: 'geometry.fill',
    stylers: [{ color: '#e6e2dc' }],
  },
  { featureType: 'landscape.natural', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  { featureType: 'poi', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'poi',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#747474' }, { lightness: '23' }],
  },
  { featureType: 'poi.government', elementType: 'geometry.fill', stylers: [{ color: '#ced7db' }] },
  { featureType: 'poi.park', elementType: 'geometry.fill', stylers: [{ color: '#c7e5c8' }] },
  {
    featureType: 'poi.place_of_worship',
    elementType: 'geometry.fill',
    stylers: [{ color: '#d6cbc7' }],
  },
  { featureType: 'poi.school', elementType: 'geometry.fill', stylers: [{ saturation: '-13' }] },
  { featureType: 'road', elementType: 'geometry', stylers: [{ lightness: '100' }] },
  {
    featureType: 'road',
    elementType: 'labels',
    stylers: [{ visibility: 'off' }, { lightness: '100' }],
  },
  { featureType: 'road.highway', elementType: 'geometry.fill', stylers: [{ color: '#ffd4a5' }] },
  { featureType: 'road.arterial', elementType: 'geometry.fill', stylers: [{ color: '#ffe9d2' }] },
  { featureType: 'road.local', elementType: 'all', stylers: [{ visibility: 'simplified' }] },
  { featureType: 'road.local', elementType: 'geometry.fill', stylers: [{ weight: '1' }] },
  { featureType: 'road.local', elementType: 'geometry.stroke', stylers: [{ weight: '0.39' }] },
  { featureType: 'road.local', elementType: 'labels', stylers: [{ visibility: 'off' }] },
  {
    featureType: 'road.local',
    elementType: 'labels.text.fill',
    stylers: [{ color: '#747474' }, { lightness: '36' }],
  },
  {
    featureType: 'road.local',
    elementType: 'labels.text.stroke',
    stylers: [{ color: '#e9e5dc' }, { lightness: '30' }],
  },
  {
    featureType: 'transit.line',
    elementType: 'geometry',
    stylers: [{ visibility: 'off' }, { lightness: '100' }],
  },
  { featureType: 'transit.station', elementType: 'all', stylers: [{ visibility: 'off' }] },
  { featureType: 'water', elementType: 'all', stylers: [{ color: '#d2e7f7' }] },
]

export const grayishMapStyles = [
  {
    featureType: 'water',
    elementType: 'geometry',
    stylers: [{ color: '#e9e9e9' }, { lightness: 17 }],
  },
  {
    featureType: 'landscape',
    elementType: 'geometry',
    stylers: [{ color: '#f5f5f5' }, { lightness: 20 }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.fill',
    stylers: [{ color: '#ffffff' }, { lightness: 17 }],
  },
  {
    featureType: 'road.highway',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#ffffff' }, { lightness: 29 }, { weight: 0.2 }],
  },
  {
    featureType: 'road.arterial',
    elementType: 'geometry',
    stylers: [{ color: '#ffffff' }, { lightness: 18 }],
  },
  {
    featureType: 'road.local',
    elementType: 'geometry',
    stylers: [{ color: '#ffffff' }, { lightness: 16 }],
  },
  {
    featureType: 'poi',
    elementType: 'geometry',
    stylers: [{ color: '#f5f5f5' }, { lightness: 21 }],
  },
  {
    featureType: 'poi.park',
    elementType: 'geometry',
    stylers: [{ color: '#dedede' }, { lightness: 21 }],
  },
  {
    elementType: 'labels.text.stroke',
    stylers: [{ visibility: 'on' }, { color: '#ffffff' }, { lightness: 16 }],
  },
  {
    elementType: 'labels.text.fill',
    stylers: [{ saturation: 36 }, { color: '#333333' }, { lightness: 40 }],
  },
  {
    elementType: 'labels.icon',
    stylers: [{ visibility: 'off' }],
  },
  {
    featureType: 'transit',
    elementType: 'geometry',
    stylers: [{ color: '#f2f2f2' }, { lightness: 19 }],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.fill',
    stylers: [{ color: '#fefefe' }, { lightness: 20 }],
  },
  {
    featureType: 'administrative',
    elementType: 'geometry.stroke',
    stylers: [{ color: '#fefefe' }, { lightness: 17 }, { weight: 1.2 }],
  },
]
